import Link from 'gatsby-link'
import * as React from 'react'
import Icon, { IconName } from './Icon'
import './SecondaryButton.scss'

export type ButtonType = 'normal' | 'destructive' | 'submit'

interface IProps {
  className?: string
  type?: ButtonType
  iconName?: IconName
  text?: string
  to?: string
  callback?: () => void
}

class SecondaryButton extends React.PureComponent<IProps> {
  public render() {
    const { className, type, iconName, text, to, callback } = this.props

    const classes =
      'secondarybutton' + ` secondarybutton__${type}` + ' ' + className + (text ? '' : ' secondarybutton__nopadding')
      
    const content = (
      <>
        {iconName !== undefined ? (
          <Icon className="secondarybutton__icon" name={iconName} />
        ) : null}
        {text}
      </>
    )

    // If 'to' is defined, show as link
    if (to !== undefined) {
      return (
        <Link className={classes} to={to}>
          <span>{content}</span>
        </Link>
      )
    }

    // Otherwise, render a button
    return <button className={classes} onClick={callback}><span>{content}</span></button>
  }
}

export default SecondaryButton



// WEBPACK FOOTER //
// ./src/components/SecondaryButton.tsx